import 'bootstrap/dist/css/bootstrap.css';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import ToolkitProvider, { CSVExport, Search } from 'react-bootstrap-table2-toolkit';
import { Redirect } from 'react-router-dom';
import { Button, Dimmer, Dropdown, Form, Grid, Header, Input, Label, Loader } from 'semantic-ui-react';
import { getWAPBusinessUnits, sortTableDates } from '../../containers/Utils/index';
import { wapGroups, wapUserStatus } from '../../containers/Utils/wapData';
import usersSearch from '../../queries/usersSearch';
import './styles.css';


const moment = require('moment');

moment.locale();

const { ExportCSVButton } = CSVExport;

const { SearchBar } = Search;

class UsersSearch extends Component {
  static propTypes = {
    client: PropTypes.shape({
      query: PropTypes.func,
    }),
    setWarningMessage: PropTypes.func.isRequired,
    setErrorMessage: PropTypes.func.isRequired,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.location) {
      return {
        usersInput: {
          wapGroup: '',
          businessUnit: '',
          firstName: '',
          lastName: '',
          emailAddress: '',
          status: '',
        },
        usersLoading: false,
      };
    }
    return null;
  }

  constructor(props) {
    super(props);
    this.state = {
      usersInput: {
        wapGroup: '',
        businessUnit: '',
        firstName: '',
        lastName: '',
        emailAddress: '',
        status: '',
      },
      usersLoading: false,
      multipleUsers: [],
      statusArray: [],
    };
  }

  onChangeValue = (_, data) => {
    const { usersInput } = this.state;
    usersInput[data.name] = data.value;
    this.setState({
      usersInput,
    });
  }

  onKeyPressExecute = (e) => {
    if (e.key === 'Enter') {
      this.search();
    }
  }

  exportCSVColumns = (onExport, action) => {
    if (action === 'REPROVISION') {
      this.multipleDatacolumns.forEach((arrayItem, idx) => {
        arrayItem.csvExport = false;
      });
      this.multipleDatacolumns[8].csvExport = true;
      this.multipleDatacolumns[9].csvExport = true;
    } else {
      this.multipleDatacolumns.forEach((arrayItem, idx) => {
        arrayItem.csvExport = true;
      });
      this.multipleDatacolumns[8].csvExport = false;
      this.multipleDatacolumns[9].csvExport = false;
    }
    onExport();
  };

  groupBy = (array, key) => array.reduce((rv, x) => { (rv[x[key]] = rv[x[key]] || []).push(x); return rv; }, {});

  populateResponse = (data) => {
    const multipleVals = [];
    data.forEach((arrayItem, idx) => {
      const item = {};
      item.key = idx;
      item.uid = arrayItem.uid;
      item.firstName = arrayItem.firstName;
      item.lastName = arrayItem.lastName;
      item.businessUnit = arrayItem.businessUnit;
      item.emailAddress = arrayItem.emailAddress;
      item.status = arrayItem.status;
      item.created = (arrayItem.created !== null ? moment(arrayItem.created).format('MM/DD/YYYY HH:mm:ss') : '');
      item.lastUpdated = (arrayItem.lastUpdated !== null ? moment(arrayItem.lastUpdated).format('MM/DD/YYYY HH:mm:ss') : '');
      item.lastLogin = (arrayItem.lastLogin !== null ? moment(arrayItem.lastLogin).format('MM/DD/YYYY HH:mm:ss') : '');
      item.operationReprovision = 'REPROVISION';
      multipleVals.push(item);
    });
    this.setState({
      multipleUsers: multipleVals,
      statusArray: this.groupBy(data, 'status'),
    });
  }

  searchUsers = debounce((queryObj) => {
    const { setWarningMessage, setErrorMessage } = this.props;

    this.props.client.query(queryObj)
      .then((response) => {
        if (response.data.users.totalFilteredUsers === 0 || response.data.users.totalFilteredUsers === null) {
          setWarningMessage('No Users found');
          this.setState({
            usersLoading: false,
          });
        } else if (response.data.users.totalFilteredUsers > 0) {
          this.populateResponse(response.data.users.users);
          this.setState({
            usersLoading: false,
          });
        }
      })
      .catch((err) => {
        this.setState({
          usersLoading: false,
        });
        setErrorMessage(err);
      });
  }, 200)

  search = () => {
    const { setWarningMessage } = this.props;
    const { usersInput } = this.state;
    if (usersInput.wapGroup === '' &&
      usersInput.businessUnit === '' &&
      usersInput.firstName === '' &&
      usersInput.lastName === '' &&
      usersInput.emailAddress === '' &&
      usersInput.status === '') {
      setWarningMessage('Please enter/select at least one filter.');
    } else {
      this.setState({
        usersLoading: true,
        multipleUsers: [],
        statusArray: [],
      });
      this.searchUsers({
        query: usersSearch,
        variables: {
          input: {
            wapGroup: usersInput.wapGroup,
            businessUnit: usersInput.businessUnit,
            firstName: usersInput.firstName,
            lastName: usersInput.lastName,
            emailAddress: usersInput.emailAddress,
            status: usersInput.status,
          },
        },
        fetchPolicy: 'network-only',
      });
    }
  }

  handleClear = () => {
    this.setState({
      usersInput: {
        wapGroup: '',
        businessUnit: '',
        firstName: '',
        lastName: '',
        emailAddress: '',
        status: '',
      },
      usersLoading: false,
      multipleUsers: [],
      statusArray: [],
    });
  }

  multipleDatacolumns = [
    {
      dataField: 'firstName',
      text: 'First Name',
      sort: true,
      headerAlign: 'center',
      headerStyle: { backgroundColor: '#c8e6c9' },
      style: { verticalAlign: 'middle', wordWrap: 'break-word' },
      csvExport: true,
    },
    {
      dataField: 'lastName',
      text: 'Last Name',
      sort: true,
      headerAlign: 'center',
      headerStyle: { backgroundColor: '#c8e6c9' },
      style: { verticalAlign: 'middle', wordWrap: 'break-word' },
      csvExport: true,
    },
    {
      dataField: 'businessUnit',
      text: 'Business Unit',
      sort: true,
      headerAlign: 'center',
      headerStyle: { backgroundColor: '#c8e6c9', width: '120px' },
      style: { verticalAlign: 'middle', wordWrap: 'break-word' },
      align: 'center',
      csvExport: true,
    },
    {
      dataField: 'emailAddress',
      text: 'Email Address',
      sort: true,
      headerAlign: 'center',
      headerStyle: { backgroundColor: '#c8e6c9' },
      style: { verticalAlign: 'middle', wordWrap: 'break-word' },
      csvExport: true,
    },
    {
      dataField: 'status',
      text: 'Status',
      sort: true,
      headerAlign: 'center',
      headerStyle: { backgroundColor: '#c8e6c9', width: '140px' },
      style: { verticalAlign: 'middle', wordWrap: 'break-word' },
      align: 'center',
      csvExport: true,
    },
    {
      dataField: 'created',
      text: 'Created',
      sort: true,
      headerAlign: 'center',
      headerStyle: { backgroundColor: '#c8e6c9', width: '140px' },
      style: { verticalAlign: 'middle', wordWrap: 'break-word' },
      align: 'right',
      sortFunc: (a, b, order) => sortTableDates(a, b, order),
      csvExport: true,
    },
    {
      dataField: 'lastUpdated',
      text: 'Last Updated',
      sort: true,
      headerAlign: 'center',
      headerStyle: { backgroundColor: '#c8e6c9', width: '140px' },
      style: { verticalAlign: 'middle', wordWrap: 'break-word' },
      align: 'right',
      sortFunc: (a, b, order) => sortTableDates(a, b, order),
      csvExport: true,
    },
    {
      dataField: 'lastLogin',
      text: 'Last Login',
      sort: true,
      headerAlign: 'center',
      headerStyle: { backgroundColor: '#c8e6c9', width: '140px' },
      style: { verticalAlign: 'middle', wordWrap: 'break-word' },
      align: 'right',
      sortFunc: (a, b, order) => sortTableDates(a, b, order),
      csvExport: true,
    },
    {
      dataField: 'emailAddress',
      text: 'emailAddress',
      hidden: true,
      csvExport: false,
    },
    {
      dataField: 'operationReprovision',
      text: 'operation',
      hidden: true,
      csvExport: false,
    },
  ];

  multiDataOptions = {
    paginationSize: 4,
    pageStartIndex: 1,
    firstPageText: '<<',
    prePageText: '<',
    nextPageText: '>',
    lastPageText: '>>',
    showTotal: true,
    disablePageTitle: true,
    sizePerPageList: [
      { text: '25', value: 25 },
      { text: '50', value: 50 },
      { text: '100', value: 100 },
      { text: '500', value: 500 },
      { text: '1000', value: 1000 },
    ],
  };

  handleCancel = () => {
    this.setState({ cancel: true });
  };

  render() {
    const { usersInput, usersLoading, cancel } = this.state;

    if (cancel) {
      return <Redirect to="/search" />;
    }

    return (
      <Dimmer.Dimmable as="div">
        {
          usersLoading &&
          <Dimmer active={usersLoading}>
            <Loader inverted>Searching Users...</Loader>
          </Dimmer>
        }
        <div styleName="search-container">
          <div>
            <Grid>
              <Grid.Column>
                <Header as="h2" dividing styleName="search-header">
                  <Grid>
                    <Grid.Column width={3}>
                      Search Users
                    </Grid.Column>
                    <Grid.Column width={9}>
                      {this.state.statusArray.ACTIVE !== undefined ?
                        <Label color="green">ACTIVE {(this.state.statusArray.ACTIVE.length)}</Label> : null}
                      {this.state.statusArray.PASSWORD_EXPIRED !== undefined ?
                        <Label color="grey">PASSWORD EXPIRED {(this.state.statusArray.PASSWORD_EXPIRED.length)}</Label> : null}
                      {this.state.statusArray.DEPROVISIONED !== undefined ?
                        <Label color="red">DEPROVISIONED {(this.state.statusArray.DEPROVISIONED.length)}</Label> : null}
                      {this.state.statusArray.SUSPENDED !== undefined ?
                        <Label color="pink">SUSPENDED {(this.state.statusArray.SUSPENDED.length)}</Label> : null}
                      {this.state.statusArray.LOCKED_OUT !== undefined ?
                        <Label color="purple">LOCKED OUT {(this.state.statusArray.LOCKED_OUT.length)}</Label> : null}
                      {this.state.statusArray.RECOVERY !== undefined ?
                        <Label color="teal">RECOVERY {(this.state.statusArray.RECOVERY.length)}</Label> : null}
                      {this.state.statusArray.STAGED !== undefined ?
                        <Label color="yellow">STAGED {(this.state.statusArray.STAGED.length)}</Label> : null}
                      {this.state.statusArray.PROVISIONED !== undefined ?
                        <Label color="brown">PROVISIONED {(this.state.statusArray.PROVISIONED.length)}</Label> : null}
                    </Grid.Column>
                    {this.state.statusArray.ACTIVE !== undefined ?
                      <Grid.Column textAlign="right" width={4}>
                        <Label>Updated:  {moment().format('MM/DD/YYYY HH:mm:ss')}</Label>
                      </Grid.Column>
                      : null}
                  </Grid>
                </Header>
                <Form size="small">
                  <Form.Group>
                    <Form.Field
                      control={Dropdown}
                      label="Business Unit"
                      placeholder="Select Business Unit"
                      value={usersInput.businessUnit}
                      options={getWAPBusinessUnits()}
                      onChange={this.onChangeValue}
                      name="businessUnit"
                      search
                      selection
                    />
                    <Form.Field
                      control={Dropdown}
                      label="Access Group"
                      placeholder="Select Group"
                      value={usersInput.wapGroup}
                      options={wapGroups}
                      onChange={this.onChangeValue}
                      name="wapGroup"
                      search
                      selection
                    />
                    <Form.Field
                      control={Dropdown}
                      label="User Status"
                      placeholder="Select Status"
                      value={usersInput.status}
                      options={wapUserStatus}
                      onChange={this.onChangeValue}
                      name="status"
                      search
                      selection
                    />
                    <Form.Field
                      control={Input}
                      label="First Name"
                      value={usersInput.firstName}
                      onChange={this.onChangeValue}
                      onKeyPress={this.onKeyPressExecute}
                      name="firstName"
                      autoComplete="disabled"
                    />
                    <Form.Field
                      control={Input}
                      label="Last Name"
                      value={usersInput.lastName}
                      onChange={this.onChangeValue}
                      onKeyPress={this.onKeyPressExecute}
                      name="lastName"
                      autoComplete="disabled"
                    />
                    <Form.Field
                      control={Input}
                      label="Email Address"
                      value={usersInput.emailAddress}
                      onChange={this.onChangeValue}
                      onKeyPress={this.onKeyPressExecute}
                      name="emailAddress"
                      autoComplete="disabled"
                    />
                    <Button styleName="search-button" type="button" onClick={this.search}>Search</Button>
                    <Button styleName="clear-button" type="button" onClick={this.handleClear}>Clear</Button>
                    <Button styleName="cancel-button" type="button" onClick={this.handleCancel}>Cancel</Button>
                  </Form.Group>
                </Form>
              </Grid.Column>
            </Grid>
          </div>
          <div>
            <Grid>
              <Grid.Column>
                <Form size="small">
                  {
                    this.state.multipleUsers.length > 0 ?
                      <ToolkitProvider
                        keyField="id"
                        data={this.state.multipleUsers}
                        columns={this.multipleDatacolumns}
                        search
                        exportCSV={{ fileName: 'WAPUsersData.csv' }}
                      >
                        {
                          props => (
                            <div>
                              <SearchBar
                                placeholder="Search this list..."
                                {...props.searchProps}
                              />
                              <ExportCSVButton
                                {...props.csvProps}
                                className="ui button"
                                style={{ marginLeft: '15px', height: '35px' }}
                                onClick={() => this.exportCSVColumns(props.csvProps.onExport, 'ALL')}
                              >
                                Export CSV
                              </ExportCSVButton>
                              <ExportCSVButton
                                {...props.csvProps}
                                className="ui button"
                                style={{ marginLeft: '15px', height: '35px' }}
                                onClick={() => this.exportCSVColumns(props.csvProps.onExport, 'REPROVISION')}
                              >
                                Export Re-Provision
                              </ExportCSVButton>
                              <BootstrapTable
                                {...props.baseProps}
                                bootstrap4
                                striped
                                hover
                                condensed
                                keyField="key"
                                data={this.state.multipleUsers}
                                columns={this.multipleDatacolumns}
                                defaultSorted={[{ dataField: 'firstName', order: 'asc' }]}
                                pagination={paginationFactory(this.multiDataOptions)}
                              />
                            </div>
                          )
                        }
                      </ToolkitProvider>
                      : null
                  }
                </Form>
              </Grid.Column>
            </Grid>
          </div>
        </div>
      </Dimmer.Dimmable>
    );
  }
}

export default UsersSearch;



// WEBPACK FOOTER //
// ./src/app/components/SearchUsers/index.js